import React from "react";
import { FormattedMessage } from "react-intl";
import TeaserActShowcase from "@default/teasers/act/teaser-act-showcase";
import { sortByDate } from "@default/lib/sort-by-date";
import {useSelector} from "react-redux";

const ShowcaseActs = ({ content }) => {
  //@todo: What happens when a showcase event has to dates with different Showcase-Acts? Does this even happen? By now this would lead to irritations.

  const releaseState = useSelector((state) => state.appStore.releaseState);
  let showcaseArtistsFromAppearances = [];


  content?.fieldAppearances?.filter(Boolean)?.map((act) => {
    if (act?.fieldShowcaseActs.length > 0) {
      showcaseArtistsFromAppearances.push(...act?.fieldShowcaseActs);
    }
  });

  if (showcaseArtistsFromAppearances.length > 0) {
    showcaseArtistsFromAppearances = showcaseArtistsFromAppearances?.filter(Boolean)?.map(
      (appearance) => {
        return appearance;
      }
    );
  }

  let showcaseArtists = [
    //...content?.fieldShowcaseArtists,
    ...showcaseArtistsFromAppearances,
  ];

  // Sort by date if date is shown, otherwise sort by name.
  if (releaseState.showDate && content?.fieldAppearances?.[0]?.fieldPlanned) {
    const venueId = content?.fieldAppearances?.[0]?.fieldVenueLocation?.id;

    showcaseArtists = showcaseArtists.sort((a, b) => {
      // Get Showcase Appearance of a
      const aAppearance = a.fieldAppearances?.find(
        (app) => app.fieldVenueLocation?.id === venueId
      );
      // Get Showcase Appearance of b
      const bAppearance = b.fieldAppearances?.find(
        (app) => app.fieldVenueLocation?.id === venueId
      );

      const aDate = parseInt(aAppearance?.fieldDateRawField?.first?.value || '0', 10);
      const bDate = parseInt(bAppearance?.fieldDateRawField?.first?.value || '0', 10);

      return aDate - bDate;
    });
  } else {
    showcaseArtists = showcaseArtists.sort((a, b) => {
      return a.title.localeCompare(b.title, 'de', { sensitivity: 'base' });
    });
  }


  if (showcaseArtists && showcaseArtists?.length >= 1) {
    return (
      <div className="showcase-acts">
        <div className="container">
          <div className="row">
            <div className="col-12 label headline-m">
              <FormattedMessage id={"acts"} />
            </div>
            {showcaseArtists.map((act, actId) => (
              <React.Fragment key={actId}>
                <TeaserActShowcase
                  item={act}
                  showcaseEvent={content}
                  pagerFullPage={false}
                />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    );
  }
};

export default ShowcaseActs;
